import React from 'react';
import Section from '../Section';

const Services: React.FC = () => {
  return (
      <Section id="services" additionalStyles={{ backgroundColor: '#222222', color: '#ffffff' }}>
        <h2>Our Services</h2>
        <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
          <li style={{ backgroundColor: '#333333', padding: '20px', borderRadius: '8px' }}>
            <h3>Rust Repair</h3>
            <p>Expert patching and prevention for frames, panels, and more.</p>
          </li>
          <li style={{ backgroundColor: '#333333', padding: '20px', borderRadius: '8px' }}>
            <h3>Welding & Fabrication</h3>
            <p>Custom metalwork for strength and style.</p>
          </li>
          <li style={{ backgroundColor: '#333333', padding: '20px', borderRadius: '8px' }}>
            <h3>Performance Builds</h3>
            <p>Engine swaps, boosts, and mods for track-ready power.</p>
          </li>
          <li style={{ backgroundColor: '#333333', padding: '20px', borderRadius: '8px' }}>
            <h3>Classic Restorations</h3>
            <p>Reviving vintage cars with modern upgrades.</p>
          </li>
        </ul>
      </Section>
  );
};

export default Services;